<template>
	<transition name="fade">
		<div v-if="visible" class="loading-mask">
			<!-- Empty Node -->
			<div class="loading-spinner"></div>
		</div>
	</transition>
</template>

<script>
import { Toast } from 'vant';

export default {
	name: 'LoadingMask',
	data() {
		return {
			visible: false
		};
	},
	methods: {
		show() {
			this.visible = true;
			Toast.loading({
				message: '',
				forbidClick: true,
				duration: 0
			});
		},
		hide() {
			this.visible = false;
			Toast.clear();
		}
	}
};
</script>

<style scoped>
.loading-mask {
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background: #fff;
	z-index: 100;
}
</style>
